import { render, staticRenderFns } from "./ComputerMenu.vue?vue&type=template&id=32f5f405&scoped=true"
import script from "./ComputerMenu.vue?vue&type=script&lang=ts"
export * from "./ComputerMenu.vue?vue&type=script&lang=ts"
import style0 from "./ComputerMenu.vue?vue&type=style&index=0&id=32f5f405&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5f405",
  null
  
)

export default component.exports